module.exports = __webpack_public_path__ + "static/4106-e9b9b78859f0d1cd78122ee55c7bdf3e.png";